import React from 'react'

/**
 * Spinner Component
 *
 * @returns {JSX.Element}
 * @constructor
 */
const Spinner = () => {
	return (
		<div className="form-modal show-modal">
			<div className="modal">

				<div style={{minWidth: '400px'}} className="modal-content">

					<div className="lds-ring">
						<div></div>
						<div></div>
						<div></div>
						<div></div>
					</div>
				</div>

			</div>

		</div>
	)
}

export default Spinner;
